import { useEffect, useState } from "react";
import API from "../../services/api";
import { useParams } from "react-router-dom";

export default function StudentAttendance() {

  const { id } = useParams();
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  const [month,setMonth] = useState(new Date().getMonth()+1);
  const [year,setYear] = useState(new Date().getFullYear());
  const [records,setRecords] = useState([]);

  const load = async () => {

    const res = await API.get("/school-admin/student-attendance/",{
      params:{
        school_code: school.school.subdomain,
        student_id: id,
        month: month,
        year: year
      }
    });

    setRecords(res.data.records || []);
  };

  useEffect(()=>{
    load();
  },[month,year]);

  return (
    <div className="page">
      <h2>Student Attendance</h2>

      <p>Present Days: {records.length}</p>

      <div>
        {records.map((d)=>(
          <div key={d}>{d}</div>
        ))}
      </div>
    </div>
  );
}